import type { CoworldHeaderArt } from "@softmax/product-ux/coworld-header";
const coworldIcons: Record<string, string | null> = {
  "gods-of-the-arena": "gods-of-the-arena.svg",
  paintbot: "paintbot.svg",
  "paintbot-royal": "paintbot.svg",
  "paintbot-cdx": "paintbot.svg",
  "paintbot-pw": "paintbot-pw.svg",
  "sugarscape-2": "sugarscape-2.svg",
  "generals-competition": "generals.svg",
  generals: "generals.svg",
  webdiplomacy: "webdiplomacy.png",
};
export function coworldIconOf(slug: string): string | undefined {
  const icon = coworldIcons[slug.replace(/\/.*$/, "")] ?? undefined;
  return icon === undefined ? undefined : `/home/icons/${icon}`;
}
export function monogramOf(name: string): string {
  const words = name.split(/\s+/).filter(Boolean);
  const [first, second] = words;

  if (first && second)
    return (first.charAt(0) + second.charAt(0)).toUpperCase();

  const word = first ?? "?";
  const inner = word.slice(1).search(/[A-Z]/);
  return inner === -1
    ? word.slice(0, 2)
    : word.charAt(0) + word.charAt(inner + 1);
}
export function coworldHeaderArt({
  slug,
  coverSrc,
  name,
  storePageIcon,
}: {
  slug: string;
  coverSrc: string | undefined;
  name: string;
  storePageIcon: string | null | undefined;
}): CoworldHeaderArt {
  if (storePageIcon) return { kind: "icon", src: storePageIcon };

  const icon = coworldIconOf(slug);

  if (icon !== undefined) return { kind: "icon", src: icon };

  if (coverSrc !== undefined) return { kind: "cover", src: coverSrc };

  return { kind: "monogram", text: monogramOf(name) };
}
